import store from '@/store'
//学校大屏
const monitors = r => require.ensure([], () => r(require('../view/monitors')), 'monitors')
const qy_monitors = r => require.ensure([], () => r(require('../view/qy_monitors')), 'qy_monitors')
const sy_monitors = r => require.ensure([], () => r(require('../view/sy_monitors')), 'sy_monitors')
const xy_monitors = r => require.ensure([], () => r(require('../view/xy_monitors')), 'xy_monitors')
const consmonitors = r => require.ensure([], () => r(require('../view/consmonitors')), 'consmonitors')
//企业微信
const qywx = r => require.ensure([], () => r(require('../qywx/index')), 'qywx')
const qwsq = r => require.ensure([], () => r(require('../qywx/qwsq')), 'qwsq')
// const sheng = r => require.ensure([], () => r(require('../view/sheng')), 'sheng')
const Login = r => require.ensure([], () => r(require('../view/login')), 'login')
const yuxin = r => require.ensure([], () => r(require('../view/yuxin')), 'yuxin')
const yuxin1 = r => require.ensure([], () => r(require('../view/yuxin1')), 'yuxin1')
const Sclogin = r => require.ensure([], () => r(require('../view/sclogin')), 'login')
const mat = r => require.ensure([], () => r(require('../view/mat')), 'mat')
const hnie = r => require.ensure([], () => r(require('../view/hnie')), 'login')
const hbLogin = r => require.ensure([], () => r(require('../view/hb')), 'login')
const jsLogin = r => require.ensure([], () => r(require('../view/js')), 'login')
const luoheLogin = r => require.ensure([], () => r(require('../view/luohe')), 'login')
const Error404 = r => require.ensure([], () => r(require('../view/404')), 'error404')
const Welcome = r => require.ensure([], () => r(require('../view/welcome')), 'welcome')
const Helptext = r => require.ensure([], () => r(require('../view/helptext')), 'helptext')
const Layout = r => require.ensure([], () => r(require('../layout/layout')), 'layout')
const Containter = r => require.ensure([], () => r(require('../layout/containter')), 'layout')
const Screen_parent = r => require.ensure([], () => r(require('../layout/screen_parent')), 'layout')

//资金监管
const supervise_index = r => require.ensure([], () => r(require('../view/supervise/index')), 'supervise')
// const Child = r => require.ensure([], () => r(require('../layout/child')), 'layout')
// 基础管理
const menhu = r => require.ensure([], () => r(require('../view/menhu')), 'menhu');
const Class = r => require.ensure([], () => r(require('../view/basic/index')), 'basic');
const Subject = r => require.ensure([], () => r(require('../view/basic/set-subject')), 'basic');
const Student = r => require.ensure([], () => r(require('../view/basic/set-student')), 'basic')
const StudentDetail = r => require.ensure([], () => r(require('../view/basic/set-student-detail')), 'basic')
const TeacherDetail = r => require.ensure([], () => r(require('../view/basic/set-teacher-detail')), 'basic')
const schoolDetail = r => require.ensure([], () => r(require('../view/basic/set-school-detail')), 'basic')
const Teacher = r => require.ensure([], () => r(require('../view/basic/set-class-teacher')), 'basic');
const Basic = r => require.ensure([], () => r(require('../view/basic/set-basic')), 'basic');
const organization = r => require.ensure([], () => r(require('../view/organization/index')), 'organization');
//课程管理
const Classmanger = r => require.ensure([], () => r(require('../view/class/index')), 'class')
const Signin = r => require.ensure([], () => r(require('../view/class/signin')), 'class')
const Rating = r => require.ensure([], () => r(require('../view/class/class-club-present')), 'class')
const Audit = r => require.ensure([], () => r(require('../view/class/audit')), 'class')
// 课程评比
const evaluation = r => require.ensure([], () => r(require('../view/evaluation/index')), 'class')
const rating_details  = r => require.ensure([], () => r(require('../view/evaluation/rating-details')), 'class')
const course_Information = r => require.ensure([], () => r(require('../view/evaluation/course-Information')), 'class')
const education_evaluation = r => require.ensure([], () => r(require('../view/evaluation/education-evaluation')), 'class')
const field_assessment = r => require.ensure([], () => r(require('../view/evaluation/field-assessment')), 'class')
const all_assessments = r => require.ensure([], () => r(require('../view/evaluation/all-assessments')), 'class')
const cours_assessment = r => require.ensure([], () => r(require('../view/evaluation/cours-assessment')), 'class')
const community_assessment = r => require.ensure([], () => r(require('../view/evaluation/community-assessment')), 'class')
const result_review= r => require.ensure([], () => r(require('../view/evaluation/result-Review')), 'class')
const record_management=r => require.ensure([], () => r(require('../view/evaluation/record-Management')), 'class')
// 学校信息
const school_Information = r => require.ensure([], () => r(require('../view/evaluation/school-Information')), 'class')
const questionnaire = r => require.ensure([], () => r(require('../view/evaluation/questionnaire')), 'class')
const newly = r => require.ensure([], () => r(require('../view/evaluation/newly')), 'class')
const questionnaire_particulars = r => require.ensure([], () => r(require('../view/evaluation/particulars')), 'class')
const advanced_School  = r => require.ensure([], () => r(require('../view/evaluation/advanced-School')), 'class')
const Cendel = r => require.ensure([], () => r(require('../view/class/class-club-cen-del')), 'class')
const Signindetail = r => require.ensure([], () => r(require('../view/class/signin-detail')), 'class')
const Classdetail = r => require.ensure([], () => r(require('../view/class/class-detail')), 'class')
const Classsign = r => require.ensure([], () => r(require('../view/class/class-sign-detail')), 'class')
const Classeval = r => require.ensure([], () => r(require('../view/class/class-eval-detail')), 'class')
const Clubtable = r => require.ensure([], () => r(require('../view/class/class-club-table')), 'class')
const Clubinfo = r => require.ensure([], () => r(require('../view/class/class-club-info')), 'class')
const Clubinforecord = r => require.ensure([], () => r(require('../view/class/record')), 'class')
const Clubcen = r => require.ensure([], () => r(require('../view/class/class-club-cen')), 'class')
const Clubachieve = r => require.ensure([], () => r(require('../view/class/class-club-achieve')), 'class')
const Clublog = r => require.ensure([], () => r(require('../view/class/class-club-log')), 'class')
const Clubexport = r => require.ensure([], () => r(require('../view/class/class-club-export')), 'class')
const Cluborder = r => require.ensure([], () => r(require('../view/class/class-club-order')), 'class')
const Clubpic = r => require.ensure([], () => r(require('../view/class/class-club-pic')), 'class')
const Clubrpt = r => require.ensure([], () => r(require('../view/class/class-club-rpt')), 'class')
const Clubachievepic = r => require.ensure([], () => r(require('../view/class/class-club-achieve-pic')), 'class')
const Clubachieveadd = r => require.ensure([], () => r(require('../view/class/class-club-achieve-add')), 'class')
const Clubpresent = r => require.ensure([], () => r(require('../view/class/class-club-present')), 'class')
const Clubsummary = r => require.ensure([], () => r(require('../view/class/class-club-summary')), 'class')
const Clubsign = r => require.ensure([], () => r(require('../view/class/class-club-sign')), 'class')
const Clubtask = r => require.ensure([], () => r(require('../view/class/class-club-task')), 'class')
const Clubsheet = r => require.ensure([], () => r(require('../view/class/class-club-sheet')), 'class');
const Clubadd = r => require.ensure([], () => r(require('../view/class/class-club-add')), 'class');
const Previewdoc = r => require.ensure([], () => r(require('../view/basic/preview_doc')), 'class');
//内容审核
const Examine = r => require.ensure([], () => r(require('../view/examine/index')), 'class');
const Evaluate = r => require.ensure([], () => r(require('../view/examine/class-evaluate')), 'class');

const Achieve = r => require.ensure([], () => r(require('../view/examine/class-achievement')), 'class');
const Leavemsg = r => require.ensure([], () => r(require('../view/examine/class-msg')), 'class');
//统计分析
const Analysis = r => require.ensure([], () => r(require('../view/analysis/index')), 'Analysis')
const Delayservice = r => require.ensure([], () => r(require('../view/delayclass/index')), 'delayclass')
const cost = r => require.ensure([], () => r(require('../view/delayclass/cost')), 'delayclass')
const Scolserve = r => require.ensure([], () => r(require('../view/delayclass/school-server')), 'delayclass')
const account = r => require.ensure([], () => r(require('../view/delayclass/account')), 'delayclass')
const Scolservedel = r => require.ensure([], () => r(require('../view/delayclass/school-server-del')), 'delayclass')
// const Serveprogramme = r => require.ensure([], () => r(require('../view/delayclass/serveprogramme')), 'delayclass')
const Serveprogramme = r => require.ensure([], () => r(require('../view/delayclass/audit')), 'delayclass')
const Servetlog = r => require.ensure([], () => r(require('../view/delayclass/servetlog')), 'delayclass')
const Serveabsentlog = r => require.ensure([], () => r(require('../view/delayclass/serveabsent')), 'delayclass')
const Servelist = r => require.ensure([], () => r(require('../view/delayclass/list')), 'delayclass')
const Servelistlist = r => require.ensure([], () => r(require('../view/delayclass/servelist')), 'delayclass')
const lead = r => require.ensure([], () => r(require('../view/delayclass/lead')), 'delayclass')
const Delayclasslist = r => require.ensure([], () => r(require('../view/delayclass/delayclasslist')), 'delayclass')
const Statisrpt = r => require.ensure([], () => r(require('../view/delayclass/statis-rpt')), 'delayclass')
const Servelog = r => require.ensure([], () => r(require('../view/delayclass/servelog')), 'delayclass')
const Userlist = r => require.ensure([], () => r(require('../view/delayclass/userList')), 'delayclass')
const card_replacement = r => require.ensure([], () => r(require('../view/delayclass/card-replacement')), 'delayclass')
//机构管理
const organizational_management = r => require.ensure([], () => r(require(
  '../operation/organization/organizational_management')), 'organizational_management')
//课程管理
const course_management = r => require.ensure([], () => r(require('../operation/organization/course_management')),
  'course_management')
  //教师管理
  const teacher_list = r => require.ensure([], () => r(require(
    '../operation/organization/teacherlist')), 'teacher_list')
//学校管理
const school_management = r => require.ensure([], () => r(require('../operation/schoolmanagement/school_management')),
  'school_management')
  // 机构管理
const administration = r => require.ensure([], () => r(require('../view/certification/administration')), 'certification');
const certification = r => require.ensure([], () => r(require('../view/certification/certification')), 'certification');
const organizationk = r => require.ensure([], () => r(require('../view/certification/organization')), 'certification');
const organizationcer = r => require.ensure([], () => r(require('../view/certification/organizationcer')), 'certification');
const teachercer = r => require.ensure([], () => r(require('../view/certification/teachercer')), 'certification');
  //学校管理
const school_lead = r => require.ensure([], () => r(require('../operation/schoolmanagement/lead')),
  'school_lead')
//学校课程管理
const school_course_management = r => require.ensure([], () => r(require(
  '../operation/schoolmanagement/school_course_management')), 'school_course_management')
//查看学校课程
const particulars = r => require.ensure([], () => r(require('../operation/schoolmanagement/particulars')),
  'particulars')
//导入指标
const target = r => require.ensure([], () => r(require('../operation/schoolmanagement/target')), 'target')
const jiesuan = r => require.ensure([], () => r(require('../view/basic/jiesuan')), 'jiesuan')
//费用明细
const expense_center = r => require.ensure([], () => r(require('../expense/center')), 'expense_center')
//学校后台-特色课程
const characteristic_course = r => require.ensure([], () => r(require('../characteristic/course')),
  'characteristic_course')
//学校后台-新增特色课程
const characteristic_newly = r => require.ensure([], () => r(require('../characteristic/newly')),
  'characteristic_newly')
//学校后台-延时课堂报名管理
const apply_index = r => require.ensure([], () => r(require('../apply/index')), 'apply_index');
const apply_shen = r => require.ensure([], () => r(require('../apply/shen')), 'apply_shen');
const apply_qrsign = r => require.ensure([], () => r(require('../apply/qrsign')), 'apply_qrsign')
//费用管理
const payment_detail_pay = r => require.ensure([], () => r(require('../view/payment-list/detail/pay'), 'payment_detail_pay'))
const payment_detail_return = r => require.ensure([], () => r(require('../view/payment-list/detail/return'), 'payment_detail_return'))
const payment_detail_salary = r => require.ensure([], () => r(require('../view/payment-list/detail/salary'), 'payment_detail_salary'))
const payment_education_accout = r => require.ensure([], () => r(require('../view/payment-list/education/accout'), 'payment_education_accout'))
const payment_education_pay = r => require.ensure([], () => r(require('../view/payment-list/education/pay'), 'payment_education_pay'))
const payment_education_return = r => require.ensure([], () => r(require('../view/payment-list/education/return'), 'payment_education_return'))
const payment_education_salary = r => require.ensure([], () => r(require('../view/payment-list/education/salary'), 'payment_education_salary'))
const payment_list = r => require.ensure([], () => r(require('../view/payment-list/index'), 'payment_list'))
const paymentList_account = r => require.ensure([], () => r(require('../view/payment-list/account'), 'paymentList_account'))
const paymentList_detail = r => require.ensure([], () => r(require('../view/payment-list/detail'), 'paymentList_detail'))
const paymentList_payroll = r => require.ensure([], () => r(require('../view/payment-list/payroll'), 'paymentList_payroll'))
const operation_cost_center = r => require.ensure([], () => r(require('../view/operation-cost-center/index'),
  'operation_cost_center'))
const wage_statistics = r => require.ensure([], () => r(require('../view/operation-cost-center/wage-statistics'),
  'wage_statistics'))
const payment_statistics = r => require.ensure([], () => r(require('../view/operation-cost-center/payment-statistics'),
  'payment_statistics'))
  const alert = r => require.ensure([], () => r(require('../view/operation-cost-center/alert'),
    'alert'))
const student_refund = r => require.ensure([], () => r(require('../view/operation-cost-center/student-refund'),
  'student_refund'))
// 报告册管理
const ReportList = r => require.ensure([], () => r(require('../view/delayclass/reportlist'), 'student_refund'))
//静态路由 edu-index
const education_data = r => require.ensure([], () => r(require('../view/big-screen/education-data'), 'education_data'))
const education_data1 = r => require.ensure([], () => r(require('../view/big-screen/education-data1'), 'education_data'))
const sheng = r => require.ensure([], () => r(require('../view/big-screen/sheng'), 'education_data'))
const education_screen = r => require.ensure([], () => r(require('../view/big-screen/edu-index'), 'education_data'))
const education_monitors = r => require.ensure([], () => r(require('../view/monitors')), 'education_data')
const big_screenmonitors = r => require.ensure([], () => r(require('../view/big-screen/monitors'), 'education_data'))
const school_screen = r => require.ensure([], () => r(require('../view/big-screen/school-screen'), 'school_screen'))
const course_screen = r => require.ensure([], () => r(require('../view/big-screen/course-screen'), 'course_screen'))
const community_screen = r => require.ensure([], () => r(require('../view/big-screen/community-screen'),
  'community_screen')) 
// 机构端
const mechanism =  r => require.ensure([], () => r(require('../view/mechanism/index'),'mechanism'));
const mechanismreview =  r => require.ensure([], () => r(require('../view/mechanism/review'),'mechanism'));
const information =  r => require.ensure([], () => r(require('../view/mechanism/essential-information'),'mechanism'));
const authorization =  r => require.ensure([], () => r(require('../view/collaborator/authorization'),'collaborator'));
const bugcollaborator =  r => require.ensure([], () => r(require('../view/collaborator/index'),'collaborator'));
// /collaborator/authorization
const collaborator =  r => require.ensure([], () => r(require('../view/collaborator/indexs'),'collaborator'));
const classlist =  r => require.ensure([], () => r(require('../view/collaborator/classlist'),'collaborator'));
const details =  r => require.ensure([], () => r(require('../view/collaborator/details'),'collaborator'));
const play =  r => require.ensure([], () => r(require('../view/collaborator/play'),'collaborator'));
// const lessonplan =  r => require.ensure([], () => r(require('../view/collaborator/lessonplan'),'collaborator'))
const lessonplan =  r => require.ensure([], () => r(require('../view/collaborator/lesson'),'collaborator'));
const basics =  r => require.ensure([], () => r(require('../view/collaborator/basics'),'collaborator'));
const edit =   r => require.ensure([], () => r(require('../view/collaborator/edit'),'collaborator'));
const preview =   r => require.ensure([], () => r(require('../view/class/preview'),'class'));
// 运营管理端
const Courseset =   r => require.ensure([], () => r(require('../view/website/course-set'),'website'));
const Matchset =   r => require.ensure([], () => r(require('../view/website/match-set'),'website'));
const Matcbanner =   r => require.ensure([], () => r(require('../view/website/banner'),'website'));
const Matcjournalism =   r => require.ensure([], () => r(require('../view/website/journalism'),'website'));
const Matcdetails =   r => require.ensure([], () => r(require('../view/website/details'),'website'));
const Matcredactk =   r => require.ensure([], () => r(require('../view/website/redact'),'website'));
const Coursedit =   r => require.ensure([], () => r(require('../view/website/course-edit'),'website'));
const training =   r => require.ensure([], () => r(require('../view/website/training'),'website'));
const compile =   r => require.ensure([], () => r(require('../view/website/compile'),'website'));
const Coursepreview =   r => require.ensure([], () => r(require('../view/website/course-preview'),'website'));
const previews =   r => require.ensure([], () => r(require('../view/website/preview'),'website'));
const caijian =   r => require.ensure([], () => r(require('../view/website/caijian'),'website'));
const time = r => require.ensure([], () => r(require('../components/time')))
const menu_role = r => require.ensure([], () => r(require('../view/menu/role')), 'menu')
const menu_jurisdiction = r => require.ensure([], () => r(require('../view/menu/jurisdiction')), 'menu')
const menu_journal = r => require.ensure([], () => r(require('../view/menu/journal')), 'menu')
const audit =   r => require.ensure([], () => r(require('../view/website/audit'),'website'));
//教育局校外管理
const teacher_administration =   r => require.ensure([], () => r(require('../operation/organization/teacher'),'teacher_administration'));
const zbill =   r => require.ensure([], () => r(require('../view/zbill'),'zbill'));
let href = window.location.href;
// let is = href.indexOf('zzhkg');
// let isk = href.indexOf('127.0.0.1');
// let rt = 0;
// if (is == -1&&isk==-1) {
//   rt = 1
// };
// if(is>-1&&isk==-1){
//   rt = 2
// }

export const constantRouterMap = [{
    path: '/login',
    name: 'login',
    component:href.indexOf('maitian') !== -1 ? mat: href.indexOf('zzhkg') !== -1 ? Sclogin : href.indexOf('hebei')!==-1?hbLogin:href.indexOf('jiangsu')!==-1?jsLogin:href.indexOf('luohe')!==-1?luoheLogin:href.indexOf('hnie.org.cn')!==-1?hnie:Login,
    meta: {
      pageTitle: '用户登录'
    }
  }, 
  {
    path: '/yuxin',
    name: 'yuxin',
    component: yuxin,
    meta: {
      pageTitle: '第三方登录'
    }
  },
  {
    path: '/menhu',
    name: 'menhu',
    component: menhu,
    meta: {
      pageTitle: '第三方登录'
    }
  },
  {
    path: '/yuxin1',
    name: 'yuxin1',
    component: yuxin1,
    meta: {
      pageTitle: '第三方登录'
    }
  },
  {
    path: '/qywx/index',
    name: 'qywx',
    component: qywx,
    meta: {
      pageTitle: '企业微信登录'
    }
  },
  {
    path: '/sheng',
    name: 'sheng',
    component: sheng,
    meta: {
      pageTitle: '省数据大屏'
    }
  },
  {
    path: '/qywx/index',
    name: 'qywx',
    component: qywx,
    meta: {
      pageTitle: '企业微信登录'
    }
  },
  {
    path: '/time',
    name: 'time',
    component: time,
    meta: {
      pageTitle: '时间插件'
    }
  },
  {
    path: '/',
    redirect: store.state.role == 1 ? '/basic' : '/class',
    component: Layout,
    meta: {
      pageTitle: '首页',
      keepAlive: false,
          isBack: false,
    },
    children: [ 
      {
        path: '/supervise_index',
        name: 'supervise_index',
        component: supervise_index,
        meta: {
          pageTitle: '资金监管'
        }
      },
      {
        path: '/zbill',
        name: 'zbill',
        component: zbill,
        meta: {
          pageTitle: '资金监管'
        }
      },
      {
        path: '/cpreview',
        name: 'previewdoc',
        component: Screen_parent,
        meta: {
          pageTitle: '预览doc',
          active: '1',
          keepAlive: false,
          isBack: false,
        } ,
        children:[{ 
          path: 'index',
          name: 'pre',
          component: Coursepreview,
          meta: {
            pageTitle: '预览',
            keepAlive: false,
            isBack: false,
          },
        },]
      },{
        path: '/previewdoc',
        name: 'previewdoc',
        component: Previewdoc,
        meta: {
          pageTitle: '预览doc',
          active: '1'
        } 
      },
      {
        path: '/consmonitors',
        name: 'consmonitors',
        component: consmonitors,
        meta: {
          pageTitle: '课程资源数据看板'
        }
      },
      { 
        path: '/previews',
        name: 'previews',
        component: previews,
        meta: {
          pageTitle: '预览',
          keepAlive: false,
          isBack: false,
        },
      },
      {
        path: '/apply_shen',
        name: 'apply_shen',
        component: apply_shen,
        meta: {
          pageTitle: '审核管理',
          active: '1'
        }
      }, {
        path: '/apply_qrsign',
        name: 'apply_qrsign',
        component: apply_qrsign,
        meta: {
          pageTitle: '报名详情',
          keepAlive: false,
          isBack: false,
        }
      },  {
        path: '/school-Information',
        name: 'school-Information',
        component: school_Information,
        meta: {
          pageTitle: '学校信息',
        }
      },  {
        path: '/questionnaire',
        name: 'questionnaire',
        component: questionnaire,
        meta: {
          pageTitle: '学校问卷调查',
        }
      },{
        path: '/advanced-School',
        name: 'advanced-School',
        component: advanced_School,
        meta: {
          pageTitle: '学校评比',
        }
      },
      {
        path: '/apply_index',
        name: 'apply_index',
        component: apply_index,
        meta: {
          pageTitle: '延时课堂报名管理',
          active: '1'
        }
      }, {
        path: '/characteristic_newly',
        name: 'characteristic_newly',
        component: characteristic_newly,
        meta: {
          pageTitle: '新增特色课程'
        }
      }, {
        path: '/characteristic_course',
        name: 'characteristic_course',
        component: characteristic_course,
        meta: {
          pageTitle: '特色课程'
        }
      }, {
        path: '/expense_center',
        name: 'expense_center',
        component: expense_center,
        meta: {
          pageTitle: '费用中心'
        }
      }, {
        path: '/target',
        name: 'target',
        component: target,
        meta: {
          pageTitle: '导入指标'
        }
      }, {
        path: '/particulars',
        name: 'particulars',
        component: particulars,
        meta: {
          pageTitle: '查看学校课程'
        }
      },
      {
        path: '/questionnaire_particulars',
        name: 'questionnaire_particulars',
        component: questionnaire_particulars,
        meta: {
          pageTitle: '问卷详情',
        }
      },{
        path: '/newly',
        name: 'newly',
        component: newly,
        meta: {
          pageTitle: '新增问卷',
        }
      }, {
        path: '/organizational_management',
        name: 'organizational_management',
        component: organizational_management,
        meta: {
          pageTitle: '机构管理'
        }
      },
      {
        path: '/course_management',
        name: 'course_management',
        component: course_management,
        meta: {
          pageTitle: '学校管理'
        }
      },
      {
        path: '/teacher_list',
        name: 'teacher_list',
        component: teacher_list,
        meta: {
          pageTitle: '教师管理'
        }
      },
      {
        path: '/teacher_administration',
        name: 'teacher_administration',
        component: teacher_administration,
        meta: {
          pageTitle: '校外机构老师管理'
        }
      },
      {
        path: '/school_management',
        name: 'school_management',
        component: school_management,
        meta: {
          pageTitle: '学校管理',
          keepAlive: false,
          isBack: false,
        }
      },
      {
        path: '/certification/administration',
        name: 'administration',
        component: administration,
        meta: {
          pageTitle: '机构管理',
          keepAlive: false,
          isBack: false,
        }
      },
      {
        path: '/certification/certification',
        name: 'certification',
        component: certification,
        meta: {
          pageTitle: '查看资质',
          keepAlive: false,
          isBack: false,
        }
      },
      {
        path: '/certification/organization',
        name: 'organizationk',
        component: organizationk,
        meta: {
          pageTitle: '机构资质',
        }
      },
      {
        path: '/certification/teachercer',
        name: 'teachercer',
        component: teachercer,
        meta: {
          pageTitle: '教师资质',
        }
      },
      {
        path: '/certification/organizationcer',
        name: 'organizationcer',
        component: organizationcer,
        meta: {
          pageTitle: '机构资质',
        }
      },
      {
        path: '/school_lead',
        name: 'school_lead',
        component: school_lead,
        meta: {
          pageTitle: '学校管理',
          keepAlive: false,
          isBack: false,
        }
      },
      {
        path: '/school_course_management',
        name: 'school_course_management',
        component: school_course_management,
        meta: {
          pageTitle: '课程管理',
          keepAlive: false,
          isBack: false,
        }
      },
      {
        path: '/basic',
        name: 'basic',
        redirect: '/basic/index',
        component: Containter,
        meta: {
          pageTitle: '基础管理',
          keepAlive: false,
          isBack: false,
        },
        children: [{
          path: 'index',
          name: 'basic-class',
          component: Class,
          meta: {
            pageTitle: '班级管理',
            keepAlive: true,
            isBack: false,
          },
        }, {
          path: 'teacher',
          name: 'basic-teacher',
          component: Teacher,
          meta: {
            pageTitle: '教师管理',
            keepAlive: true,
            isBack: false,
          },
        }, {
          path: 'student',
          name: 'basic-student',
          redirect: 'student/index',
          component: Containter,
          meta: {
            keepAlive: true,
            isBack: false,
          },
          children: [{
            icon: 'ti-home',
            path: 'index',
            name: 'basic-students',
            component: Student,
            meta: {
              pageTitle: '学生管理',
              keepAlive: true,
              isBack: false,
            }
          }, {
            icon: 'ti-home',
            path: 'student-detail',
            name: 'basic-student-detail',
            component: StudentDetail,
            meta: {
              keepAlive: false,
              pageTitle: '批量导入',
              isBack: false,
            }
          }, {
            icon: 'ti-home',
            path: 'teacher-detail',
            name: 'basic-teacher-detail',
            component: TeacherDetail,
            meta: {
               pageTitle: '批量导入',
              keepAlive: false,
              isBack: false,
            }
          },{
            icon: 'ti-home',
            path: 'school-detail',
            name: 'basic-school-detail',
            component: schoolDetail,
            meta: {
               pageTitle: '批量导入',
              keepAlive: false,
              isBack: false,
            }
          }]
        }, {
          path: 'subject',
          name: 'basic-subject',
          component: Subject,
          meta: {
            pageTitle: '学科管理',
            keepAlive: false,
            isBack: false,
          }
        }, {
                  path: '/jiesuan',
                  name: 'jiesuan',
                  component: jiesuan,
                  meta: {
                    pageTitle: '导入结算单',
                   keepAlive: false,
                   isBack: false,
                 }
                },{
          path: 'basic',
          name: 'class-basic',
          component: Basic,
          meta: {
            pageTitle: '基础设置',
            keepAlive: true, //是否缓存
            isBack: false //是否保存当前高度
          }
        }]
      }, {
        path: '/class',
        name: 'class',
        redirect: '/class/',
        component: Containter,
        meta: {
          roles: ['1'],
          pageTitle: '课程管理'
        }, 
        children: [{
            path: '/',
            name: 'class-manager',
            component: Containter,
            meta: {
              pageTitle: '课程管理'
            },
            children: [{
                path: 'index',
                name: 'class-signin',
                component: Classmanger,
                meta: {
                  pageTitle: '课程管理'
                },
              },
              {
                path: '/',
                name: 'class-detail',
                // redirect: '/class-detail/index',
                component: Containter,
                meta: {
                  pageTitle: '评价标准'
                },
                children: [{
                    path: 'index',
                    name: 'class-signin-detail',
                    component: Classdetail,
                    meta: {
                      pageTitle: '评价标准',
                      keepAlive: false,
                      isBack: false,
                    },
                  }, {
                    path: 'sign',
                    name: 'class-detail-signin',
                    component: Classsign,
                    meta: {
                      pageTitle: '评价标准',
                      keepAlive: false,
                      isBack: false,
                    },
                  }, {
                    path: 'evaluation',
                    name: 'class-detail-evaluation ',
                    component: Classeval,
                    meta: {
                      pageTitle: '评价标准',
                      keepAlive: false,
                      isBack: false,
                    },
                  }, {
                    path: 'club-info',
                    name: 'class-club ',
                    component: Clubinfo,
                    meta: {
                      pageTitle: '社团信息',
                      keepAlive: false,
                      isBack: false,
                    },
                  }, {
                    path: 'record',
                    name: 'class-club ',
                    component: Clubinforecord,
                    meta: {
                      pageTitle: '课程记录',
                      keepAlive: false,
                      isBack: false,
                    },
                  },{
                    path: 'club-table',
                    name: 'class-table ',
                    component: Clubtable,
                    meta: {
                      pageTitle: '课程表',
                      keepAlive: false,
                      isBack: false,
                    },
                  }, {
                    path: 'club-cent',
                    name: 'class-club ',
                    component: Clubcen,
                    meta: {
                      pageTitle: '课程内容',
                      keepAlive: false,
                      isBack: false,
                    },
                  }, {
                    path: 'club-sign',
                    name: 'class-club-sign ',
                    component: Clubsign,
                    meta: {
                      pageTitle: '选课报名',
                      keepAlive: false,
                      isBack: false,
                    },
                  }, {
                    path: 'club-order',
                    name: 'class-club ',
                    component: Cluborder,
                    meta: {
                      pageTitle: '学生名单',
                      keepAlive: false,
                      isBack: false,
                    },
                  }, {
                    path: 'club-log',
                    name: 'class-club-log ',
                    component: Clublog,
                    meta: {
                      pageTitle: '考勤记录',
                      keepAlive: false,
                      isBack: false,
                    },
                  }, {
                    path: 'club-achieve',
                    name: 'class-club-achieve ',
                    component: Clubachieve,
                    meta: {
                      pageTitle: '课程成果',
                      keepAlive: false,
                      isBack: false,
                    },
                  }, {
                    path: 'club-evaluate',
                    name: 'class-club-evaluate',
                    component: Classdetail,
                    meta: {
                      pageTitle: '课程评价',
                      keepAlive: false,
                      isBack: false,
                    },
                  }, {
                    path: 'club-summary',
                    name: 'class-club-summary',
                    component: Clubsummary,
                    meta: {
                      pageTitle: '期末总结',
                      keepAlive: false,
                      isBack: false,
                    },
                  }, {
                    path: 'club-present',
                    name: 'class-club-present',
                    component: Clubpresent,
                    meta: {
                      pageTitle: '课程报告',
                      keepAlive: false,
                      isBack: false,
                    },
                  }, {
                    path: 'club-pic',
                    name: 'class-club-pic',
                    component: Clubpic,
                    meta: {
                      pageTitle: '照片集',
                      keepAlive: false,
                      isBack: false,
                    },
                  }, {
                    path: 'achieve-pic',
                    name: 'class-club-pic',
                    component: Clubachievepic,
                    meta: {
                      pageTitle: '查看学生作品',
                      keepAlive: false,
                      isBack: false,
                    },
                  }, {
                    path: 'achieve-add',
                    name: 'class-club-pic',
                    component: Clubachieveadd,
                    meta: {
                      pageTitle: '添加成果',
                      keepAlive: false,
                      isBack: false,
                    },
                  }, {
                    path: 'club-task',
                    name: 'class-club-pic',
                    component: Clubtask,
                    meta: {
                      pageTitle: '任务单',
                      keepAlive: false,
                      isBack: false,
                    },
                  }, {
                    path: 'club-sheet',
                    name: 'class-club-sheet',
                    component: Clubsheet,
                    meta: {
                      pageTitle: '评价标准',
                      keepAlive: false,
                      isBack: false,
                    },
                  }, {
                    path: 'club-add',
                    name: 'class-club-add',
                    component: Clubadd,
                    meta: {
                      pageTitle: '新增社团',
                      keepAlive: false,
                      isBack: false,
                    },
                  }, {
                    path: 'club-export',
                    name: 'class-club-export',
                    component: Clubexport,
                    meta: {
                      pageTitle: '导入评价标准',
                      keepAlive: false,
                      isBack: false,
                    },
                  }, {
                    path: 'club-cendel',
                    name: 'class-club-Cendel',
                    component: Cendel,
                    meta: {
                      pageTitle: '课程纲要',
                      keepAlive: false,
                      isBack: false,
                    },
                  },
                  {
                    path: 'course-evaluation',
                    name: 'course-evaluation',
                    component: evaluation,
                    meta: {
                      pageTitle: '课程评比',
                      keepAlive: true,
                      isBack: false,
                    }
                  }, 
                  {
                    path: 'rating-details',
                    name: 'rating-details',
                    component: rating_details,
                    meta: {
                      pageTitle: '评比详情',
                    }
                  },
                  {
                    path: 'course-Information',
                    name: 'course-Information',
                    component: course_Information,
                    meta: {
                      pageTitle: '课程详情',
                      keepAlive: true,
                      isBack: false,
                    }
                  },
                  {
                    path: 'education-evaluation',
                    name: 'education-evaluation',
                    component: education_evaluation,
                    meta: {
                      pageTitle: '课程评比',
                      keepAlive: true,
                      isBack: false,
                    }
                  },
                  {
                    path: 'field-assessment',
                    name: 'field-assessment',
                    component: field_assessment,
                    meta: {
                      pageTitle: '实地考核',
                      keepAlive: true,
                      isBack: false,
                    }
                  },
                  {
                    path: 'all-assessments',
                    name: 'all-assessments',
                    component: all_assessments,
                    meta: {
                      pageTitle: '实地考核',
                      keepAlive: true,
                      isBack: false,
                    }
                  },
                  {
                    path: 'cours-assessment',
                    name: 'cours-assessment',
                    component: cours_assessment,
                    meta: {
                      pageTitle: '课程考核',
                      keepAlive: true,
                      isBack: false,
                    }
                  },
                  {
                    path: 'community-assessment',
                    name: 'community-assessment',
                    component: community_assessment,
                    meta: {
                      pageTitle: '社团考核',
                      keepAlive: true,
                      isBack: false,
                    }
                  },
                  {
                    path: 'result-review',
                    name: 'result-review',
                    component: result_review,
                    meta: {
                      pageTitle: '成果审核',
                      keepAlive: true,
                      isBack: false,
                    }
                  },
                  {
                    path: 'record-management',
                    name: 'record-management',
                    component: record_management,
                    meta: {
                      pageTitle: '成果审核',
                      keepAlive: true,
                      isBack: false,
                    }
                  }
                ]
              }
            ]
          },
          {
            path: 'sign',
            redirect: 'sign/index',
            name: 'class-signins',
            component: Containter,
            meta: {
              pageTitle: '报名管理'
            },
            children: [{
                path: 'index',
                name: 'class-signin',
                component: Signin,
                meta: {
                  pageTitle: '报名管理'
                },
              },
              {
                path: 'sign-detail',
                redirect: 'index',
                name: 'sign-detail',
                component: Containter,
                meta: {
                  pageTitle: '报名管理'
                },
                children: [{
                  path: 'index',
                  name: 'class-signin-detail',
                  component: Signindetail,
                  meta: {
                    pageTitle: '报名管理'
                  },
                }]
              }
            ]
          }, {
            path: 'rating',
            name: 'class-rating',
            component: Clubrpt,
            meta: {
              pageTitle: '巡课报告'
            }
          }, {
            path: 'present',
            name: 'class-present',
            component: Clubpresent,
            meta: {
              pageTitle: '巡课报告'
            }
          },
          {
            path: 'audit',
            name: 'audit',
            component: Audit,
            meta: {
              pageTitle: '结算审核'
            }
          },
        ],
      },
      {
        path: '/organization/index',
        name: 'organization',
        component: organization,
        meta: {
          pageTitle: '机构管理',
        } 
      },
      {
        path: '/examine',
        name: 'examine',
        component: Containter,
        children: [{
            path: 'log',
            name: 'examine-rating',
            component: Achieve,
            meta: {
              pageTitle: '课程记录'
            }
          },
          {
            path: 'evalue',
            name: 'examine-signin',
            component: Evaluate,
            meta: {
              pageTitle: '评价互动'
            }
          },
          {
            path: 'index',
            name: 'examine-log',
            component: Examine,
            meta: {
              pageTitle: '学生作品'
            }
          }, {
            path: 'msg',
            name: 'examine-msg',
            component: Leavemsg,
            meta: {
              pageTitle: '学生留言'
            }
          }
        ],
        meta: {
          roles: ['1'],
          pageTitle: '内容审核'
        },

      },
      {
        path: '/delayedclass',
        name: 'delay',
        component: Containter,
        children: [{
            path: 'pro',
            name: 'class-delay-pro',
            component: Delayservice,
            meta: {
              pageTitle: '学校服务方案'
            }
          }, {
            path: 'report-list',
            name: 'report-list',
            component: ReportList,
            meta: {
              pageTitle: '报告册管理'
            }
          },
          {
            path: 'statistics',
            name: 'class-delay-statistics',
            component: Scolserve,
            meta: {
              pageTitle: '学校服务统计'
            }
          },
          {
            path: 'account',
            name: 'account',
            component: account,
            meta: {
              pageTitle: '学校延时结算'
            }
          },
          {
            path: 'cost',
            name: 'cost',
            component: cost,
            meta: {
              pageTitle: '学校费用统计'
            }
          },
          {
            path: 'statisdel',
            name: 'class-delay-del',
            component: Scolservedel,
            meta: {
              pageTitle: '学校服务统计'
            }
          },
          {
            path: 'servelist',
            name: 'class-delay-del',
            component: Servelist,
            meta: {
              pageTitle: '服务课表'
            }
          },
          {
            path: 'servelistlist',
            name: 'class-delay-del',
            component: Servelistlist,
            meta: {
              pageTitle: '服务课表'
            }
          },
          {
            path: 'lead',
            name: 'class-delay-del',
            component: lead,
            meta: {
              pageTitle: '导入服务课表'
            }
          },
          {
            path: 'servetlog',
            name: 'class-delay-del',
            component: Servetlog,
            meta: {
              pageTitle: '服务记录'
            }
          },
          {
            path: 'absentlog',
            name: 'class-delay-del',
            component: Serveabsentlog,
            meta: {
              pageTitle: '请假记录'
            }
          },
          {
            path: 'serveprogramme',
            name: 'class-delay-programme',
            component: Serveprogramme,
            meta: {
              pageTitle: '服务方案'
            }
          },
          {
            path: 'delayclass',
            name: 'class-delay-list',
            component: Delayclasslist,
            meta: {
              pageTitle: '延时课堂'
            }
          },
          {
            path: 'card-replacement',
            name: 'card-replacement',
            component: card_replacement,
            meta: {
              pageTitle: '补卡申请'
            }
          },
          {
            path: 'servelog',
            name: 'class-delay-list',
            component: Servelog,
            meta: {
              pageTitle: '服务记录'
            }
          },
          {
            path: 'statisrpt',
            name: 'class-statis-rpt',
            component: Statisrpt,
            meta: {
              pageTitle: '统计报告'
            }
          }

        ],
        meta: {
          roles: ['1'],
          pageTitle: '统计分析'
        },
      },
      {
        path: '/mechanism',
        name: 'mechanism',
        redirect: '/mechanism/index',
        component: Containter,
        meta: {
          pageTitle: '机构端',
          keepAlive: false,
          isBack: false,
        },
        children: [{
          path: 'index',
          name: 'mechanism',
          component: mechanism,
          meta: {
            pageTitle: '课程管理',
            keepAlive: false,
            isBack: false,
          },
        },{
          path: 'information',
          name: 'mechanism',
          component: information,
          meta: {
            pageTitle: '基本信息',
            keepAlive: false,
            isBack: false,
          },
        },{ 
          path: 'mechanismreview',
          name: 'mechanismreview',
          component: mechanismreview,
          meta: {
            pageTitle: '课程预览',
            keepAlive: false,
            isBack: false,
          },
        }]
      }, 
      {
        path: '/menu',
        name: 'menu',
        redirect: '/menu/role',
        component: Containter,
        meta: {
          pageTitle: '机构端',
          keepAlive: false,
          isBack: false,
        },
        children: [
          {
            path: 'role',
            name: 'menu',
            component: menu_role,
            meta: {
              pageTitle: '角色管理'
            }
          },
          {
            path: 'jurisdiction',
            name: 'menu',
            component: menu_jurisdiction,
            meta: {
              pageTitle: '权限管理'
            }
          },
          {
            path: 'journal',
            name: 'menu',
            component: menu_journal,
            meta: {
              pageTitle: '日志管理'
            }
          },
        ]
      },
      {
        path: '/website',
        name: 'website',
        redirect: '/website/index',
        component: Containter,
        meta: {
          pageTitle: '机构端',
          keepAlive: false,
          isBack: false,
        },
        children: [
          {
            path: 'audit',
            name: 'website',
            component: audit,
            meta: {
              pageTitle: '机构管理',
              keepAlive: false,
              isBack: false,
            },
          },
          {
            path: 'index',
            name: 'website',
            component: Courseset,
            meta: {
              pageTitle: '机构管理',
              keepAlive: false,
              isBack: false,
            },
          },{ 
            path: 'match',
            name: 'website',
            component: Matchset,
            meta: {
              pageTitle: '机构管理',
              keepAlive: false,
              isBack: false,
            },
          },{ 
            path: 'banner',
            name: 'website',
            component: Matcbanner,
            meta: {
              pageTitle: '机构管理',
              keepAlive: false,
              isBack: false,
            },
          },{ 
            path: 'journalism',
            name: 'website',
            component: Matcjournalism,
            meta: {
              pageTitle: '机构管理',
              keepAlive: false,
              isBack: false,
            },
          },{ 
            path: 'details',
            name: 'website',
            component: Matcdetails,
            meta: {
              pageTitle: '机构管理',
              keepAlive: false,
              isBack: false,
            },
          },{ 
            path: 'redact',
            name: 'website',
            component: Matcredactk,
            meta: {
              pageTitle: '机构管理',
              keepAlive: false,
              isBack: false,
            },
          },{ 
            path: 'cedit',
            name: 'website',
            component: Coursedit,
            meta: {
              pageTitle: '编辑课程',
              keepAlive: false,
              isBack: false,
            },
          } ,
          { 
            path: 'training',
            name: 'website',
            component: training,
            meta: {
              pageTitle: '教具管理',
              keepAlive: false,
              isBack: false,
            },
          },
          { 
            path: 'compile',
            name: 'website',
            component: compile,
            meta: {
              pageTitle: '编辑教具',
              keepAlive: false,
              isBack: false,
            },
          } ,
          { 
            path: 'caijian',
            name: 'website',
            component: caijian,
            meta: {
              pageTitle: '编辑教具',
              keepAlive: false,
              isBack: false,
            },
          } ,
        ]
      },
      {
        path: '/collaborator',
        name: 'collaborator',
        redirect: '/collaborator/index',
        component: Containter,
        meta: {
          pageTitle: '机构端',
          keepAlive: false,
          isBack: false,
        },
        children: [
          {
            path: 'index',
            name: 'collaborator',
            component: collaborator,
            meta: {
              pageTitle: '机构管理',
              keepAlive: true,
              isBack: false,
            },
          },{
            path: 'bugcollaborator',
            name: 'bugcollaborator',
            component: bugcollaborator,
            meta: {
              pageTitle: '购买记录',
              keepAlive: true,
              isBack: false,
            },
          },
          {
            path: 'details',
            name: 'collaborator',
            component: details,
            meta: {
              pageTitle: '课程详情',
              keepAlive: true,
              isBack: false,
            },
          },
          {
            path: 'play',
            name: 'collaborator',
            component: play,
            meta: {
              pageTitle: '课程预览',
              keepAlive: true,
              isBack: false,
            },
          },
        {
          path: 'classlist',
          name: 'collaborator',
          component: classlist,
          meta: {
            pageTitle: '课程列表',
            keepAlive: true,
            isBack: false,
          },
        },{
          path: 'lessonplan',
          name: 'collaborator',
          component: lessonplan,
          meta: {
            pageTitle: '查看课程',
            keepAlive: true,
            isBack: false,
            showAll: true,
          },
        },{
          path: 'authorization',
          name: 'collaborator',
          component: authorization,
          meta: {
            pageTitle: '权限设置',
            keepAlive: true,
            isBack: false,
          },
        },{
          path: 'basics',
          name: 'basics',
          component: basics,
          meta: {
            pageTitle: '基础信息',
            keepAlive: true,
            isBack: false,
          },
        },{
          path: 'edit',
          name: 'edit',
          component: edit,
          meta: {
            pageTitle: '基础设置',
            keepAlive: true,
            isBack: false,
          },
        }]
      },
      {
        path: '/education-data/monitors',
        name: 'monitors',
        component: monitors,
        meta: {
          pageTitle: '大屏数据',
          keepAlive: false,
          isBack: false,
        },
      },
      {
        path: '/education-data/qy_monitors',
        name: 'qy_monitors',
        component: qy_monitors,
        meta: {
          pageTitle: '大屏数据',
          keepAlive: false,
          isBack: false,
        },
      },
      {
        path: '/education-data/sy_monitors',
        name: 'sy_monitors',
        component: sy_monitors,
        meta: {
          pageTitle: '大屏数据',
          keepAlive: false,
          isBack: false,
        },
      },
      {
        path: '/education-data/xy_monitors',
        name: 'xy_monitors',
        component: xy_monitors,
        meta: {
          pageTitle: '大屏数据',
          keepAlive: false,
          isBack: false,
        },
      },
      
  {
    path: '/education-data',
    name: 'education-data',
    redirect: '/education-data/index',
    // component: Screen_parent,
    component: Containter,
    meta: {
      pageTitle: '大屏数据',
      keepAlive: false,
      isBack: false,
    },
    children: [{
      path: 'index',
      name: 'education-data',
      component: education_data,
      meta: {
        pageTitle: '大屏数据',
        keepAlive: true,
        isBack: false, 
        screenFlag:2,
      },
    },
    {
      path: 'monitorst',
      name: 'big_screenmonitors',
      component: big_screenmonitors,
      meta: {
        pageTitle: '大屏数据',
        keepAlive: true,
        isBack: false, 
        screenFlag:2,
      },
    },
    {
      path: 'index1',
      name: 'education-data1',
      component: education_data1,
      meta: {
        pageTitle: '大屏数据',
        keepAlive: true,
        isBack: false, 
        screenFlag:2,
      },
    },{
      path: 'sheng',
      name: 'sheng',
      component: sheng,
      meta: {
        pageTitle: '课程数据',
        keepAlive: true,
        isBack: false,
        screenFlag:2,
      },
    },{
      path: 'course-screen',
      name: 'course-screen',
      component: course_screen,
      meta: {
        pageTitle: '课程数据',
        keepAlive: true,
        isBack: false,
        screenFlag:2,
      },
    }, {
      path: 'school-screen',
      name: 'school_screen',
      component: school_screen,
      meta: {
        pageTitle: '学校—延时服务大屏数据',
        keepAlive: true,
        isBack: false,
      },
    }, {
      path: 'community-screen',
      name: 'community_screen',
      component: community_screen,
      meta: {
        pageTitle: '学校—社团大屏数据',
        keepAlive: true,
        isBack: false,
      },
    }]
  },
      {
        path: '/paymentList',
        name: 'paymentList',
        redirect: '/paymentList/index',
        component: payment_list,
        meta: {
          pageTitle: '费用中心',
          keepAlive: false,
          isBack: false,
        },
        children: [{
          path: 'index',
          name: 'payment-List',
          component: Class,
          meta: {
            pageTitle: '费用中心',
            keepAlive: true,
            isBack: false,
          },
        }]
      },
      {
        path: '/paymentList/payroll',
        name: 'paymentList_payroll',
        component: paymentList_payroll,
        meta: {
          pageTitle: '工资统计'
        }
      },
      {
        path: '/paymentList/detail_pay',
        name: 'payment_detail_pay',
        component: payment_detail_pay,
        meta: {
          pageTitle: '缴费明细'
        }
      },
      {
        path: '/paymentList/detail_return',
        name: 'payment_detail_return',
        component: payment_detail_return,
        meta: {
          pageTitle: '退费明细'
        }
      },
      {
        path: '/paymentList/detail_salary',
        name: 'payment_detail_salary',
        component: payment_detail_salary,
        meta: {
          pageTitle: '工资明细'
        }
      },
      {
        path: '/paymentList/education_accout',
        name: 'payment_education_accout',
        component: payment_education_accout,
        meta: {
          pageTitle: '费用结算'
        }
      },
      {
        path: '/paymentList/education_pay',
        name: 'payment_education_pay',
        component: payment_education_pay,
        meta: {
          pageTitle: '缴费明细'
        }
      },
      {
        path: '/paymentList/education_salary',
        name: 'payment_education_salary',
        component: payment_education_salary,
        meta: {
          pageTitle: '工资明细'
        }
      },
      {
        path: '/paymentList/education_return',
        name: 'payment_education_return',
        component: payment_education_return,
        meta: {
          pageTitle: '退费明细'
        }
      },
      {
        path: '/paymentList/account',
        name: 'paymentList_account',
        component: paymentList_account,
        meta: {
          pageTitle: '费用结算'
        }
      },
      {
        path: '/paymentList/detail',
        name: 'paymentList_detail',
        component: paymentList_detail,
        meta: {
          pageTitle: '费用明细'
        }
      },
      {
        path: '/operation-cost-center',
        name: 'operation-cost-center',
        redirect: '/operation-cost-center/index',
        component: Containter,
        meta: {
          pageTitle: '费用中心',
          keepAlive: false,
          isBack: false,
        },
        children: [{
          path: 'index',
          name: 'operation-cost-center',
          component: operation_cost_center,
          meta: {
            pageTitle: '费用中心',
            keepAlive: true,
            isBack: false,
          },
        }, {
          path: 'wage-statistics',
          name: 'wage-statistics',
          component: wage_statistics,
          meta: {
            pageTitle: '工资统计',
            keepAlive: true,
            isBack: false,
          },
        }, {
          path: 'payment-statistics',
          name: 'payment-statistics',
          component: payment_statistics,
          meta: {
            pageTitle: '缴费统计',
            keepAlive: true,
            isBack: false,
          },
        }, {
          path: 'alert',
          name: 'alert',
          component: alert,
          meta: {
            pageTitle: '下载结算单',
            keepAlive: false,
            isBack: false,
          },
        }, {
          path: 'student-refund',
          name: 'student_refund',
          component: student_refund,
          meta: {
            pageTitle: '学生退费',
            keepAlive: true,
            isBack: false,
          },
        }]
      }, {
        path: '/analysis',
        name: 'analysis',
        redirect: '/analysis/index',
        component: Containter,
        children: [{
            path: 'index',
            name: 'class-analysis',
            component: Analysis,
            meta: {
              pageTitle: '统计分析'
            }
          },
          {
            path: 'sign',
            name: 'class-analysis-signin',
            component: Rating,
            meta: {
              pageTitle: '统计分析2'
            }
          }
        ],
        meta: {
          roles: ['1'],
          pageTitle: '统计分析'
        },
      }, {
        path: '/userList',
        name: 'userList',
        redirect: '/userList/index',
        component: Containter,
        children: [{
            path: 'index',
            name: 'userList',
            component: Userlist,
            meta: {
              pageTitle: '用户查询'
            }
          },
          {
            path: 'manager',
            name: 'userList-manager',
            component: Rating,
            meta: {
              pageTitle: '区域管理'
            }
          }
        ],
      }, 
    ],
  },
  {
    path: '/preview',
    name: 'course-evaluation',
    component: preview,
    meta: {
      pageTitle: '预览报告',
      keepAlive: true,
      isBack: false,
    } 
  }, 
  {
    path: '/screen',
    name: 'screen',
    // redirect: '',
    component: Screen_parent, 
    meta: {
      pageTitle: '大屏数据',
      keepAlive: false,
      isBack: false,
    },
    children: [{
      path: 'monitors',
      // name: 'education-course',
      component: education_monitors,
      meta: {
        pageTitle: '大屏数据',
        keepAlive: true,
        isBack: false,
        screenFlag:1,
      },
    },{
      path: 'index',
      name: 'education-course',
      component: education_screen,
      meta: {
        pageTitle: '大屏数据',
        keepAlive: true,
        isBack: false,
        screenFlag:1,
      },
    },{
      path: 'eindex',
      name: 'education-index',
      component: education_data,
      meta: {
        pageTitle: '大屏数据',
        keepAlive: true,
        isBack: false,
        screenFlag:1,
      },
    },{
      path: 'course',
      name: 'course',
      component: course_screen,
      meta: {
        pageTitle: '课程数据',
        keepAlive: true,
        isBack: false,  
        screenFlag:1,
      },
    }, {
      path: 'school',
      name: 'school_screen',
      component: school_screen,
      meta: {
        pageTitle: '学校—延时服务大屏数据',
        keepAlive: true,
        isBack: false,
      },
    }, {
      path: 'community-screen',
      name: 'community_screen',
      component: community_screen,
      meta: {
        pageTitle: '学校—社团大屏数据',
        keepAlive: true,
        isBack: false,
      },
    }]
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: Welcome,
    meta: {
      pageTitle: '欢迎使用社团之家'
    }
  },
  {
    path: '/helpUs',
    name: 'helpUs',
    component: Helptext,
    meta: {
      pageTitle: '帮助文档'
    }
  },
  
  {
    path: '*',
    name: 'error',
    component: Error404,
    meta: {
      pageTitle: '404'
    }
  },
]
// 导出需要显示菜单的
export default constantRouterMap



// WEBPACK FOOTER //
// ./src/router/router.js